import ProfileSimpleForm from './ProfileSimpleForm'

export default ProfileSimpleForm
